import React, { useState } from "react";
import styled from "styled-components";
import backArrow from "@src/assets/ico_arrow_back.png";
import { transferToNative } from "@src/lib/WebAppBridge";
import ArchitectADList from "./ui/ArchitectADList";

const ArchitectList = () => {
    return (
        <Layout>
            <Header>
                <div
                    className="backBtn"
                    onClick={() => {
                        transferToNative("done", "closeWebView");
                    }}
                >
                    <img src={backArrow} alt="뒤로가기" />
                </div>
                <div className="title">건축사 광고 관리</div>
            </Header>

            <Content>
                <ArchitectADList />
            </Content>
        </Layout>
    );
};

const Layout = styled.div`
    width: 100vw;
    height: 100vh;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 14px;

    .backBtn {
        position: absolute;
        left: 24px;
        width: 10px;
        height: 17px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0c002c;
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
    }
`;

export default ArchitectList;
